import React from "react";
import Header from "./header";
import Footer from "./footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../pages/home";
import About from "../pages/about";
import Services from "../pages/services";
import Contact from "../pages/contact";
import ScrollToTop from "react-scroll-to-top";
import PrivacyPolicy from "../pages/privacy-policy";
import DeleteAccount from "../pages/delete-account";

function Content() {
  return (
    <BrowserRouter>
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
        </Routes>
        <Footer />
      </div>
      <ScrollToTop smooth />
    </BrowserRouter>
  );
}

export default Content;
